import { Component, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'sham-i-invoice-04',
  standalone: true,
  templateUrl: '../../assets/invoice-04.svg',
  encapsulation: ViewEncapsulation.None
})
export class ShamInvoice04Icon {}
